let fieldConfig = {
    version: 1.5,
    profileType: '44',
    table: [
        {
            label: '项目名称',
            selected: true,
            default: false,
            name: 'shortAndMatName',
            sort: false,
        },
        {
            label: '规格型号',
            selected: true,
            default: false,
            name: 'spec',
            sort: false,
        },
        {
            label: '单位',
            selected: true,
            default: false,
            name: 'unit',
            sort: false,
        },
        {
            label: '数量',
            selected: true,
            default: false,
            name: 'quantity',
            sort: false,
            type: 'quantity'
        },
        {
            label: '单价（含税）',
            selected: true,
            default: false,
            name: 'taxPrice',
            sort: false,
            type:'hs',
        },
        {
            label: '金额（含税）',
            selected: true,
            default: false,
            name: 'adValoremTotal',
            sort: false,
            type:'hs',
        },
        {
            label: '单价（不含税）',
            selected: false,
            default: false,
            name: 'price',
            sort: false,
            type:'bhs',
        },
        {
            label: '金额（不含税）',
            selected: false,
            default: false,
            name: 'amount',
            sort: false,
            type:'bhs',
        },

        {
            label: '税率/征收率',
            selected: true,
            default: false,
            name: 'taxRate',
            sort: false,
            type:'rate'
        },
        {
            label: '税额',
            selected: true,
            default: false,
            name: 'taxAmount',
            sort: false,
        },
    ],
}

export default fieldConfig



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/directive/inforConfirm/fieldConfig.js